import { QueryFunctionContext } from '@tanstack/react-query';
import { api } from '../services/api';
import { IDataNoPagination } from '../types/shared';

export interface IPermanenciaMedia {
  permanencia_media_dias: number;
}

export interface IAniversarioEmpresa {
  razao_social: string;
  dt_cli_desde: string;
  cnpj: string;
  external_id: string;
}

export interface IDatasEmpresaFilters {
  data_inicial: string;
  data_final: string;
  emp_id?: number;
}

export interface IAniversarioFilters {
  mes_inicial: number;
  mes_final: number;
  emp_id?: number;
}

export const useDatasEmpresa = () => {
  const getPermanenciaMedia = async (
    key: QueryFunctionContext,
  ): Promise<IDataNoPagination<IPermanenciaMedia>> => {
    const filters = key.queryKey?.[1] ?? {};
    const res = await api.get<IDataNoPagination<IPermanenciaMedia>>(
      '/api/v1/datas-empresa/permanencia-media',
      {
        params: filters,
      },
    );
    return res.data;
  };

  const getAniversarios = async (
    key: QueryFunctionContext,
  ): Promise<IDataNoPagination<IAniversarioEmpresa[]>> => {
    const filters = key.queryKey?.[1] ?? {};
    const res = await api.get<IDataNoPagination<IAniversarioEmpresa[]>>(
      '/api/v1/datas-empresa/aniversarios',
      {
        params: filters,
      },
    );
    return res.data;
  };

  return {
    getPermanenciaMedia,
    getAniversarios,
  };
};
